import React from 'react';
import { portfolioData } from '../../../data/portfolio';

const Blogs = props => {
    const handleBlogClick = (title, url) => {
        window.gtag('event', 'click', {
            'event_category': 'Blog',
            'event_label': title,
            'url': url
        });
    };

    const { blogs } = portfolioData;

    return (
        <div className="w-full px-6 md:px-12 py-12" id="blogs">
            <div className="w-full mx-auto">
                {/* Section Header */}
                <div className="mb-12 relative pl-4 border-l-4 border-primary-500">
                    <h4 className="text-sm font-bold tracking-widest text-primary-600 uppercase mb-2 font-sans">MY ARTICLES</h4>
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 font-display">Latest Blogs</h1>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {blogs.map((blog, index) => (
                        <div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow duration-300 border border-gray-100 flex flex-col group">
                            <div className="flex items-center justify-between mb-4">
                                <span className="text-primary-600 font-semibold text-sm bg-primary-50 px-3 py-1 rounded-full">
                                    {blog.platform}
                                </span>
                                <time className="text-gray-400 text-sm font-medium">{blog.date}</time>
                            </div>

                            <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-primary-600 transition-colors line-clamp-2">
                                {blog.title}
                            </h3>

                            <div className="mt-auto pt-6">
                                <a
                                    href={blog.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => handleBlogClick(blog.title, blog.url)}
                                    className="inline-flex items-center text-primary-600 font-semibold group-hover:underline"
                                >
                                    Read Article
                                    <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

Blogs.propTypes = {}

export default Blogs
